import { PLANS } from '@aeon-karaoke/cloud-convex/model/plans';
import { Button } from '@/component';

interface WelcomeUploadStepProps {
  /** Free accounts are told their monthly upload allowance. */
  isFree: boolean;
  onChooseFile: () => void;
}

/** First run, step 3: the dashed drop zone that hands off to the create flow. */
export function WelcomeUploadStep({ isFree, onChooseFile }: WelcomeUploadStepProps) {
  return (
    <div className="mt-11">
      <h1 className="text-[38px] font-semibold leading-[1.08] tracking-[-0.03em]">Make your first track</h1>
      <p className="mt-3 max-w-[48ch] text-base leading-[1.5] text-mute">
        Upload a song you love. We separate the vocal, build the instrumental, and time the lyrics. The finished
        track is yours to queue on any Aeon system.
      </p>
      <div className="mt-[30px] rounded-lg border border-dashed border-line2 px-8 py-[52px] text-center">
        <div className="text-lg font-semibold tracking-[-0.015em]">Drop an audio file here</div>
        <p className="mt-[9px] text-sm text-mute">WAV, FLAC, MP3 or M4A. Up to 12 minutes.</p>
        <Button onClick={onChooseFile} className="mt-5 px-[19px]">
          Choose a file
        </Button>
      </div>
      <p className="mt-[18px] max-w-[56ch] text-[13px] leading-[1.6] text-faint">
        Upload only music you have the right to use.
        {isFree && ` Your free plan includes ${PLANS.free.monthlyCreateLimit} tracks a month.`}
      </p>
    </div>
  );
}
